export function PaymentBadges({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 flex-wrap ${className}`} data-testid="payment-badges">
      {/* Visa */}
      <div className="h-9 px-3.5 bg-white rounded-md flex items-center shadow-sm" title="Visa">
        <span className="text-[#1A1F71] font-bold italic text-lg tracking-tight leading-none">VISA</span>
      </div>
      {/* Mastercard */}
      <div className="h-9 px-3 bg-white rounded-md flex items-center gap-1.5 shadow-sm" title="Mastercard">
        <span className="relative flex items-center">
          <span className="w-4 h-4 rounded-full bg-[#EB001B]" />
          <span className="w-4 h-4 rounded-full bg-[#F79E1B] -ml-2 mix-blend-multiply" />
        </span>
        <span className="text-[#1a1a1a] text-[11px] font-semibold lowercase">mastercard</span>
      </div>
      {/* iyzico ile öde */}
      <div className="h-9 px-3.5 bg-[#1E64FF] rounded-md flex items-center gap-1.5 shadow-sm" title="iyzico ile Öde">
        <span className="text-white font-bold text-sm lowercase">iyzico</span>
        <span className="text-white/85 text-[11px]">ile öde</span>
      </div>
    </div>
  );
}
